type Env = {
  API_URL: string;
};

const local: Env = {
  API_URL: "http://localhost:3000",
};

const development: Env = {
  API_URL: "https://api.qatool.dev.centerstagetech.com",
};

const staging: Env = {
  API_URL: "https://api.qatool.staging.centerstagetech.com",
};

const production: Env = {
  API_URL: "https://api.qatool.centerstagetech.com",
};

const matchDevelopment = window.location.href.match(
  /qatool\.dev\.centerstagetech\.com/,
);

const matchStaging = window.location.href.match(
  /qatool\.staging\.centerstagetech\.com/,
);

const matchProduction = window.location.href.match(
  /qatool\.centerstagetech\.com/,
);

export const env: Env = matchDevelopment
  ? development
  : matchProduction
  ? production
  : matchStaging
  ? staging
  : local;
